























































































//@ts-ignore
import store from "../../store";
import {Component, Vue} from "vue-property-decorator";
import {CatalogFilter} from "../../../types";
import EventApi from "../../api/EventsApi";

@Component({
    props: {
    }
})

export default class GameCatalogFilter extends Vue{
    private typeFilterIsOpened: boolean = false;
    private gameplayFilterIsOpened: boolean = false;
    private typeFilterModel: number = 0;
    private gameplayFilterModel: number = 0;
    private playersNumberFilterModel: number = 0;
    private durationFilterModel: string = '';

    private ageRadios = [
        {
            value: 10,
        },
        {
            value: 13,
        },
        {
            value: 17,
        },
        {
            value: 18,
        }
    ];
    private durationRadios = [
        {
            value: '0-19',
            label: '<20'
        },
        {
            value: '20-30',
            label: '20-30'
        },
        {
            value: '30-40',
            label: '30-40'
        },
        {
            value: '41-1000',
            label: '>40'
        }
    ];
    private playersNumberRadios = [
        {
            value: 1,
            name: 'players-number'
        },
        {
            value: 2,
            name: 'players-number'
        },
        {
            value: 3,
            name: 'players-number'
        },
        {
            value: 4,
            name: 'players-number'
        },
        {
            value: 5,
            name: 'players-number'
        },
        {
            value: 6,
            name: 'players-number'
        }
    ];

    private ageFilterValue: number = 0;

    /**
     * Фильтры каталога игр по типу
     */
    private get typesFilters(): null|Array<CatalogFilter>
    {
        return store.getters.getTypesCatalogFilters;
    }

    /**
     * Фильтры каталога игр по геймплею
     */
    private get gameplayFilters(): null|Array<CatalogFilter>
    {
        return store.getters.getGameplayCatalogFilters;
    }

    /**
     * Название текущего фильтра по типам
     */
    private get currentTypeFilterName(): string
    {
        if (!this.typesFilters) {
            // @ts-ignore
            return this.$t('message.all');
        }
        const filtered = this.typesFilters.filter(item => {
            return item.isActive;
        });

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0].name;
        }

        // @ts-ignore
        return this.$t('message.all');
    }

    /**
     * Название текущего фильтра по геймплею
     */
    private get currentGameplayFilterName(): string
    {
        if (!this.gameplayFilters) {
            // @ts-ignore
            return this.$t('message.all');
        }
        const filtered = this.gameplayFilters.filter(item => {
            return item.isActive;
        });

        if (typeof filtered[0] !== 'undefined') {
            return filtered[0].name;
        }

        // @ts-ignore
        return this.$t('message.all');
    }

    /**
     * Закрыть список сортировки
     * @private
     */
    private closeTypeDropdown(): void
    {
        this.typeFilterIsOpened = false;
    }

    /**
     * Закрыть/открыть список сортировки
     * @private
     */
    private toggleTypeDropdown(): void
    {
        this.typeFilterIsOpened = !this.typeFilterIsOpened;
    }

    /**
     * Закрыть список сортировки
     * @private
     */
    private closeGameplayDropdown(): void
    {
        this.gameplayFilterIsOpened = false;
    }

    /**
     * Закрыть/открыть список сортировки
     * @private
     */
    private toggleGameplayDropdown(): void
    {
        this.gameplayFilterIsOpened = !this.gameplayFilterIsOpened;
    }

    /**
     * Фильтрация по типу
     * @private
     */
    private filterByType(id: number): void
    {
        this.typeFilterIsOpened = false;
        this.typeFilterModel = id;
        store.dispatch('setActiveTypeCatalogFilter', this.typeFilterModel);
        this.$emit('apply-type-filter', this.typeFilterModel);
    }

    /**
     * Фильтрация по геймплею
     * @private
     */
    private filterByGameplay(id: number): void
    {
        this.gameplayFilterIsOpened = false;
        this.gameplayFilterModel = id;
        store.dispatch('setActiveGameplayCatalogFilter', this.gameplayFilterModel);
        this.$emit('apply-gameplay-filter', this.gameplayFilterModel);
    }

    /**
     * Фильтрация по возрасту
     * @private
     */
    private filterByAge(val: number): void
    {
        if (val !== this.ageFilterValue) {
            this.ageFilterValue = val;
        } else {
            this.ageFilterValue = 0;
        }
        this.$emit('apply-age-filter', this.ageFilterValue);
    }

    /**
     * Фильтрация по продолжительности
     * @private
     */
    private filterByDuration(val: string): void
    {
        if (val !== this.durationFilterModel) {
            this.durationFilterModel = val;
        } else {
            this.durationFilterModel = '';
        }
        this.$emit('apply-duration-filter', this.durationFilterModel);
    }

    /**
     * Фильтрация по кол-ву игроков
     * @private
     */
    private filterByPlayersNumber(val: number): void
    {
        if (val !== this.playersNumberFilterModel) {
            this.playersNumberFilterModel = val;
        } else {
            this.playersNumberFilterModel = 0;
        }
        this.$emit('apply-players-number-filter', this.playersNumberFilterModel);
    }

    private resetFilters(): void
    {
        this.typeFilterModel = 0;
        this.gameplayFilterModel = 0;
        this.playersNumberFilterModel = 0;
        this.durationFilterModel = '';
        this.ageFilterValue = 0;
        store.dispatch('setActiveGameplayCatalogFilter', this.gameplayFilterModel);
        store.dispatch('setActiveTypeCatalogFilter', this.typeFilterModel);
        this.$emit('reset-filters');
    }
}
